module.exports = __webpack_public_path__ + "static/media/puzzle-5-bg.a96f98e1.svg";